import React from 'react';

const AmountGrid = ({ qrcodeitems = [], numberWithCommas }) => {
  // แบ่งข้อมูลเป็นกลุ่มๆ ละ 3 items
  const chunkedItems = [];
  for (let i = 0; i < qrcodeitems.length; i += 4) {
    chunkedItems.push(qrcodeitems.slice(i, i + 4));
  }

  return (
    <div className="container">
      {chunkedItems.map((row, rowIndex) => (
        <div key={rowIndex} className="d-flex justify-content-around gap-2 mb-2">
          {row.map((item, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className={`btn-money${rowIndex} flex-fill`}
             
            >
              {numberWithCommas(item.amount)}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default AmountGrid;